function createStory(shortName, title, preview, mainImage, story) {
    return {
        shortName: shortName,
        title: title,
        preview: preview,
        mainImage: mainImage,
        story: story
    };
}

export default createStory;